
import config from "@/assets/config";
import { proyecto } from "@/mixins/proyecto.mixins.js";
export default {
  mixins: [proyecto],
  name: "blank",

  head() {
    return {
      titleTemplate: "%s - " + this.proyecto_v.codetitle,

      meta: [
        {
          hid: "description",
          name: "description",
          content: this.proyecto_v.descripcion,
        },
      ],
    };
  },

  beforeMount() {
    this.$axios.setHeader("Cache-Control", "no-cache");
  },
};
